import { Navigate, useLocation } from 'react-router-dom';
import { validateDependencies, isRouteAuthenticated } from './useIsRouteAuthenticated';
import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import { menuAuthenticateAtom } from '../atoms/menuAuthenticateAtom';
import { userAtom } from '../atoms/userAtom';
import toastr from 'toastr';
import { PulseLoader } from 'react-spinners';

export const RouteAuthentication = ({children, menuLink, isAdmin}) => {
  const location = useLocation();         
  const [menuUser] = useRecoilState(menuAuthenticateAtom);
  const [user] = useRecoilState(userAtom);

  if (!menuUser || menuUser.length === 0) {
    return <PulseLoader size={10} color={'#333'} loading={true} />;
  }

  const isDependenciesValid = validateDependencies(menuLink, menuUser, user); 
  if (isDependenciesValid !== null) {
    toastr.error(isDependenciesValid);
    return <Navigate to="/welcome" state={{ from: location }} replace />;
  }

  else if (!isRouteAuthenticated(menuLink, isAdmin, menuUser, user)) {
    toastr.error('Usuário não tem acesso a essa funcionalidade.');
    return <Navigate to="/welcome" state={{ from: location }} replace />;
  }

  return children;
};

RouteAuthentication.propTypes = {
  children: PropTypes.node.isRequired,
  menuLink: PropTypes.string,
  isAdmin: PropTypes.bool
};

export default RouteAuthentication;